import axios from 'axios'

export const companiesNotifications = {
  namespaced: true,
  state: {
    data: null,
    loading: false,
    loadError: false,
    errors: null,
  },
  mutations: {
    readNotifications(state) {
      state.loading = true
      state.loadError = false
      state.errors = null
    },
    readNotificationsSuccess(state, payload) {
      state.data = payload
      state.loading = false
    },
    readNotificationsFailure(state, errors) {
      state.loading = false
      state.loadError = true
      state.errors = errors
    }
  },
  actions: {
    readNotifications({ commit }, payload) {
      commit('readNotifications')
      axios
        .get(`/api/companies/${ payload.company_uuid }/notifications.json?per=${ payload.per }`)
        .then(res => {
          commit('readNotificationsSuccess', res.data)
        })
        .catch(err => {
          commit('readNotificationsFailure', err)
          console.error(err)
        })
    }
  }
}
